import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, createBlock as _createBlock, renderSlot as _renderSlot } from "vue"

const _hoisted_1 = { key: 0 }
const _hoisted_2 = { style: {"padding":"8px"} }
const _hoisted_3 = { style: {"padding":"14px 2px"} }
const _hoisted_4 = ["innerHTML"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_skeleton_item = _resolveComponent("el-skeleton-item")!
  const _component_el_space = _resolveComponent("el-space")!
  const _component_el_col = _resolveComponent("el-col")!
  const _component_el_row = _resolveComponent("el-row")!
  const _component_el_skeleton = _resolveComponent("el-skeleton")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_empty = _resolveComponent("el-empty")!
  const _component_app_loader_empty = _resolveComponent("app-loader-empty")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_app_loader_empty, {
      loading: _ctx.loading,
      resources: _ctx.resources
    }, {
      loading: _withCtx(() => [
        (_ctx.loading)
          ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
              _createVNode(_component_el_skeleton, {
                style: {"width":"100%"},
                loading: _ctx.loading,
                animated: ""
              }, {
                template: _withCtx(() => [
                  _createElementVNode("div", _hoisted_2, [
                    _createVNode(_component_el_space, { size: 10 }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_skeleton_item, {
                          variant: "circle",
                          style: {"width":"50px","height":"50px"}
                        }),
                        _createVNode(_component_el_skeleton_item, {
                          variant: "h1",
                          style: {"width":"350px"}
                        })
                      ]),
                      _: 1
                    }),
                    _createElementVNode("div", _hoisted_3, [
                      _createVNode(_component_el_space, {
                        "w-100": "",
                        size: 10
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_skeleton_item, {
                            variant: "text",
                            style: {"width":"300px"}
                          }),
                          _createVNode(_component_el_skeleton_item, {
                            variant: "text",
                            style: {"width":"50px"}
                          })
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_el_skeleton_item, {
                        variant: "text",
                        style: {"width":"90%"}
                      }),
                      _createVNode(_component_el_skeleton_item, {
                        variant: "text",
                        style: {"width":"80%"}
                      }),
                      _createVNode(_component_el_skeleton_item, {
                        variant: "text",
                        style: {"width":"60%"}
                      })
                    ]),
                    _createVNode(_component_el_row, null, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_col, { span: 24 / 3 }, {
                          default: _withCtx(() => [
                            _createVNode(_component_el_skeleton_item, {
                              variant: "h1",
                              style: {"width":"50px"}
                            })
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_el_col, {
                          style: {"text-align":"right"},
                          span: 24 / 3
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_el_skeleton_item, {
                              variant: "h1",
                              style: {"width":"50px"}
                            })
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_el_col, {
                          style: {"text-align":"right"},
                          span: 24 / 3
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_el_skeleton_item, {
                              variant: "h1",
                              style: {"width":"50px"}
                            })
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    })
                  ])
                ]),
                _: 1
              }, 8, ["loading"])
            ]))
          : _createCommentVNode("", true)
      ]),
      empty: _withCtx(() => [
        (_ctx.resources === undefined || _ctx.resources.length === 0)
          ? (_openBlock(), _createBlock(_component_el_empty, {
              key: 0,
              image: _ctx.img
            }, {
              description: _withCtx(() => [
                _cache[0] || (_cache[0] = _createElementVNode("h2", { "m-tb-0": "" }, "Oops!", -1)),
                _createElementVNode("p", { innerHTML: _ctx.description }, null, 8, _hoisted_4)
              ]),
              default: _withCtx(() => [
                false
                  ? (_openBlock(), _createBlock(_component_el_button, {
                      key: 0,
                      "is-borderless": "",
                      plain: "",
                      type: "primary",
                      icon: "el-icon-plus",
                      size: "large",
                      onClick: _ctx.clickedEmpty
                    }, {
                      default: _withCtx(() => [...(_cache[1] || (_cache[1] = [
                        _createTextVNode(" Source Talents ", -1)
                      ]))]),
                      _: 1
                    }, 8, ["onClick"]))
                  : _createCommentVNode("", true),
                _renderSlot(_ctx.$slots, "default")
              ]),
              _: 3
            }, 8, ["image"]))
          : _createCommentVNode("", true)
      ]),
      _: 3
    }, 8, ["loading", "resources"])
  ]))
}